import React, { useEffect, useState } from 'react';
import { homeownerRecords } from '../utils/homeownerApi';

export default function TaskPhotoThumb({ path }) {
  const [url, setUrl] = useState('');

  useEffect(() => {
    let cancel = false;
    if (!path) return undefined;
    homeownerRecords({
      resource: 'client_documents',
      action: 'signed_url',
      path,
    }).then((data) => {
      if (!cancel && data && data.url) setUrl(data.url);
    }).catch(() => {});
    return () => {
      cancel = true;
    };
  }, [path]);

  if (!url) return null;
  return (
    <img
      src={url}
      alt="Saved photo"
      style={{ width: 56, height: 56, objectFit: 'cover', borderRadius: 8, flex: '0 0 auto' }}
    />
  );
}
